import { useQuery } from 'convex/react'
import { api } from '@convex/_generated/api'

// Stats type matching Convex return
export interface PropertyStats {
  total: number
  published: number
  draft: number
  archived: number
}

/**
 * Hook for fetching property statistics (counts by status).
 * Uses Convex's real-time queries - stats update automatically when properties change.
 */
export function usePropertyStats() {
  const data = useQuery(api.properties.stats, {})

  return {
    data,
    isLoading: data === undefined,
    error: null as Error | null, // Convex throws on error
  }
}
